import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';

var prefixIE = function prefixIE(flex) {
  if (/MSIE|Trident/.test(window.navigator.userAgent) && (flex === 'flex' || flex === 'inline-flex')) {
    return "-ms-".concat(flex);
  }

  return flex;
};

var Box = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Box, _React$PureComponent);

  var _super = _createSuper(Box);

  function Box() {
    _classCallCheck(this, Box);

    return _super.apply(this, arguments);
  }

  _createClass(Box, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          htmlType = _this$props.htmlType,
          alignContent = _this$props.alignContent,
          alignItems = _this$props.alignItems,
          alignSelf = _this$props.alignSelf,
          flex = _this$props.flex,
          flexBasis = _this$props.flexBasis,
          flexDirection = _this$props.flexDirection,
          flexFlow = _this$props.flexFlow,
          flexGrow = _this$props.flexGrow,
          flexShrink = _this$props.flexShrink,
          flexWrap = _this$props.flexWrap,
          justifyContent = _this$props.justifyContent,
          order = _this$props.order,
          className = _this$props.className,
          children = _this$props.children,
          display = _this$props.display,
          color = _this$props.color,
          backgroundColor = _this$props.backgroundColor,
          padding = _this$props.padding,
          margin = _this$props.margin,
          width = _this$props.width,
          height = _this$props.height;
      var flexStyle = {
        display: prefixIE(display),
        alignContent: alignContent,
        justifyContent: justifyContent,
        alignItems: alignItems,
        alignSelf: alignSelf,
        flexBasis: flexBasis,
        flexFlow: flexFlow,
        flexDirection: flexDirection,
        flexWrap: flexWrap,
        flex: flex,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        order: order,
        color: color,
        backgroundColor: backgroundColor,
        padding: padding,
        margin: margin,
        width: width,
        height: height
      };
      return /*#__PURE__*/React.createElement(htmlType, {
        className: className,
        style: flexStyle
      }, children);
    }
  }]);

  return Box;
}(React.PureComponent);

Box.propTypes = {
  htmlType: PropTypes.string,
  display: PropTypes.string,
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string
};
Box.defaultProps = {
  htmlType: 'div',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start'
};
export default Box;